import 'devextreme/dist/css/dx.material.blue.light.css';
import styled from '@emotion/styled';
import Skeleton from 'components/Skeleton';
import { Container } from 'components/Layout';


export default function ReportLoader() {
  const items = Array.from({ length: 50 }, (_, i) => i + 1);

  return (
    <LoaderContainer>
      {items.map((item) => (
        <Loader
          key={item}
          variant="rectangular"
          width="100%"
          height={56}
        />
      ))}
    </LoaderContainer>
  );
}

const LoaderContainer = styled(Container)`
  width: 100%;
  padding: ${({ theme }) => `${theme.padding.l} 0 0 ${theme.padding.xl}`};
  padding-left: 0;
  @media (max-width: ${({ theme }) => `${theme.breakpoints.values.md}px`}) {
    padding-top: ${({ theme }) => ` ${theme.padding.m}`};
  }
`;

const Loader = styled(Skeleton)`
  margin-bottom: ${({ theme }) => theme.margin.s};
`;